import { JobOpeningDetailsContainer } from './containers/JobOpeningDetailsContainer';

export const JobOpeningDetails = JobOpeningDetailsContainer;
export default JobOpeningDetails;

export * from './components';
export * from './containers';
export * from './hooks';
export * from './Interfaces';
export * from './constants';
export * from './functions';
